/** Light haptic tick (Android/Chrome supports Vibration API; silently ignored elsewhere). */
let last = 0;
export function haptic(ms = 8) {
  const now = Date.now();
  if (now - last < 60) return;
  last = now;
  try {
    if (navigator.vibrate && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) navigator.vibrate(ms);
  } catch (_) {}
}
